import {TeamIcon} from "../../../assets/icons/Team";
import MembersLabel from "./MembersLabel";
import useAppContext from "../../../hooks/useAppContext";
import {Campaign} from "../../../types/CampaignProps";
import "./campaign-thumb-audience.css";
import {useEffect} from "react";
import {getCampaignMembers} from "../../../api/getCampaignMembers";
import useUserContext from "../../../hooks/useUserContext";

interface CampaignThumbAudienceProps {
    campaign?: Campaign;
    isEditorMode: boolean;
    isSending: boolean;
    onSendManualCampaignClick: (event: any) => void;
    membersWithPhoneNumbers?: number;
}

const CampaignThumbAudience = ({ campaign, isEditorMode, isSending, onSendManualCampaignClick, membersWithPhoneNumbers }: CampaignThumbAudienceProps) => {
    const { data: { segments } } = useAppContext();
    const { selectedDomain } = useUserContext();

    useEffect(() => {
        if(selectedDomain && campaign?.id) {
            // getCampaignMembers(selectedDomain, campaign.id);
        }
    }, [selectedDomain, campaign?.id]);

    return (
        <div className="campaign-audience-container">
            <div className="audience-icon"><TeamIcon width={18} color="#d3d3d3" /></div>
            <MembersLabel
                isLoading={segments.isLoading}
                totalMembers={campaign?.customersCount || 0}
                totalSegments={campaign?.segments?.length || 0}
                isEditingMode={isEditorMode}
                totalMembersSentTo={campaign?.insights?.delivered || 0}
                onResendClick={onSendManualCampaignClick}
                isResending={isSending}
            />
        </div>
    )
}

export default CampaignThumbAudience;